import { Injectable } from "@angular/core";
import { SuccessComponent } from "../Dialoges/ResponseDIaloges/success/success.component";
import { MatDialog } from "@angular/material/dialog";
import { ErrorComponent } from "../Dialoges/ResponseDIaloges/error/error.component";
import { unauthComponent } from "../Dialoges/ResponseDIaloges/UnAuthWarning/unauth.component";

@Injectable({
  providedIn: "root",
})
export class NotifierService {
  constructor(public dialog: MatDialog) {}

  async onSuccess(
    materialIcon: string,
    header: string,
    subTitle: string
  ): Promise<void> {
    const dialogRef = this.dialog.open(SuccessComponent, {
      minWidth: "30vw",
      data: {
        materialIcon,
        header,
        subTitle,
      },
    });
    await dialogRef
      .afterClosed()
      .toPromise()
      .then((result) => {
        return Promise.resolve(result);
      });
  }

  async onError(
    materialIcon: string,
    header: string,
    subTitle: string
  ): Promise<void> {
    const dialogRef = this.dialog.open(ErrorComponent, {
      minWidth: "30vw",
      data: {
        materialIcon,
        header,
        subTitle,
      },
    });
    await dialogRef
      .afterClosed()
      .toPromise()
      .then((result) => {
        return Promise.resolve(result);
      });
  }
  async onNotAllowed(
    materialIcon: string,
    header: string,
    subTitle: string
  ): Promise<void> {
    const dialogRef = this.dialog.open(unauthComponent, {
      minWidth: "30vw",
      data: {
        materialIcon,
        header,
        subTitle,
      },
    });
    await dialogRef
      .afterClosed()
      .toPromise()
      .then((result) => {
        return Promise.resolve(result);
      });
  }
}
